
const states = [
  { abbr: 'AL', name: 'Alabama', country: 'US' },
  { abbr: 'AK', name: 'Alaska', country: 'US' },
  { abbr: 'AZ', name: 'Arizona', country: 'US' },
  { abbr: 'AR', name: 'Arkansas', country: 'US' },
  { abbr: 'CA', name: 'California', country: 'US' },
  { abbr: 'CO', name: 'Colorado', country: 'US' },
  { abbr: 'CT', name: 'Connecticut', country: 'US' },
  { abbr: 'DC', name: 'District Of Columbia', country: 'US' },
  { abbr: 'DE', name: 'Delaware', country: 'US' },
  { abbr: 'FL', name: 'Florida', country: 'US' },
  { abbr: 'GA', name: 'Georgia', country: 'US' },
  { abbr: 'HI', name: 'Hawaii', country: 'US' },
  { abbr: 'ID', name: 'Idaho', country: 'US' },
  { abbr: 'IL', name: 'Illinois', country: 'US' },
  { abbr: 'IN', name: 'Indiana', country: 'US' },
  { abbr: 'IA', name: 'Iowa', country: 'US' },
  { abbr: 'KS', name: 'Kansas', country: 'US' },
  { abbr: 'KY', name: 'Kentucky', country: 'US' },
  { abbr: 'LA', name: 'Louisiana', country: 'US' },
  { abbr: 'ME', name: 'Maine', country: 'US' },
  { abbr: 'MD', name: 'Maryland', country: 'US' },
  { abbr: 'MA', name: 'Massachusetts', country: 'US' },
  { abbr: 'MI', name: 'Michigan', country: 'US' },
  { abbr: 'MN', name: 'Minnesota', country: 'US' },
  { abbr: 'MS', name: 'Mississippi', country: 'US' },
  { abbr: 'MO', name: 'Missouri', country: 'US' },
  { abbr: 'MT', name: 'Montana', country: 'US' },
  { abbr: 'NE', name: 'Nebraska', country: 'US' },
  { abbr: 'NV', name: 'Nevada', country: 'US' },
  { abbr: 'NH', name: 'New Hampshire', country: 'US' },
  { abbr: 'NJ', name: 'New Jersey', country: 'US' },
  { abbr: 'NM', name: 'New Mexico', country: 'US' },
  { abbr: 'NY', name: 'New York', country: 'US' },
  { abbr: 'NC', name: 'North Carolina', country: 'US' },
  { abbr: 'ND', name: 'North Dakota', country: 'US' },
  { abbr: 'OH', name: 'Ohio', country: 'US' },
  { abbr: 'OK', name: 'Oklahoma', country: 'US' },
  { abbr: 'OR', name: 'Oregon', country: 'US' },
  { abbr: 'PA', name: 'Pennsylvania', country: 'US' },
  { abbr: 'RI', name: 'Rhode Island', country: 'US' },
  { abbr: 'SC', name: 'South Carolina', country: 'US' },
  { abbr: 'SD', name: 'South Dakota', country: 'US' },
  { abbr: 'TN', name: 'Tennessee', country: 'US' },
  { abbr: 'TX', name: 'Texas', country: 'US' },
  { abbr: 'UT', name: 'Utah', country: 'US' },
  { abbr: 'VT', name: 'Vermont', country: 'US' },
  { abbr: 'VA', name: 'Virginia', country: 'US' },
  { abbr: 'WA', name: 'Washington', country: 'US' },
  { abbr: 'WV', name: 'West Virginia', country: 'US' },
  { abbr: 'WI', name: 'Wisconsin', country: 'US' },
  { abbr: 'WY', name: 'Wyoming', country: 'US' },
];

const canProvinces = [
  {
    name: 'Alberta',
    abbr: 'AB',
    country: 'CA'
  },
  {
    name: 'British Columbia',
    abbr: 'BC',
    country: 'CA'
  },
  {
    name: 'Manitoba',
    abbr: 'MB',
    country: 'CA'
  },
  {
    name: 'New Brunswick',
    abbr: 'NB',
    country: 'CA'
  },
  {
    name: 'Newfoundland and Labrador',
    abbr: 'NL',
    country: 'CA'
  },
  {
    name: 'Northwest Territories',
    abbr: 'NT',
    country: 'CA'
  },
  {
    name: 'Nova Scotia',
    abbr: 'NS',
    country: 'CA'
  },
  {
    name: 'Nunavut',
    abbr: 'NU',
    country: 'CA'
  },
  {
    name: 'Ontario',
    abbr: 'ON',
    country: 'CA'
  },
  {
    name: 'Prince Edward Island',
    abbr: 'PE',
    country: 'CA'
  },
  {
    name: 'Quebec',
    abbr: 'QC',
    country: 'CA'
  },
  {
    name: 'Saskatchewan',
    abbr: 'SK',
    country: 'CA'
  },
  {
    name: 'Yukon Territory',
    abbr: 'YT',
    country: 'CA'
  }
];


export default states.concat(canProvinces);
